import Http from '../utils/axios'
const rt = '/api-zendai/report'
const user = '/api-zendai/user'
const workflow = '/api-zendai/workflow'
const investment = '/api-zendai/investment'
export default {
    //获取列表
    getList(params){
        return Http.post(`${rt}/reportConfig/list`,params, false)
    },
    create(params){
        return Http.post(`${rt}/reportConfig/create`,params, false)
    },
    update(params){
        return Http.post(`${rt}/reportConfig/update`,params, false)
    },
    getMall(params){
        return Http.get(`${user}/v1/e/mall/getMallAuthoriHomePage`,params, false)
    },
    getReportData(id,params){
        return Http.post(`${rt}/report/${id}`,params, false)
    },
    getworkflowToMe(params){
        return Http.post(`${workflow}/e/flow/auditCenter/findFlowsRelatedToMe`,params, false)
    },
    getBuilding(params){
        return Http.get(`${investment}/e/mall/queryInvestMallDetailByCode`,params, false)
    }
}
